import 'preact-material-components/style.css';
import GlobalHeader from './GlobalHeader';
import { ThemeProvider } from 'styled-components';
import SideMenu from './SideMenu';
import { Component } from 'preact';
import { connect } from 'preact-redux';


class Header extends Component {
	constructor() {
		super();
		this.state = {
			menuOpen: false
		}
		this.toggleMenu = this.toggleMenu.bind(this);
	}

	toggleMenu() {
		this.setState({
			menuOpen: !this.state.menuOpen
		})
	}

	render(props) {
		return (
			<ThemeProvider theme={props.theme}>
				<div>
					<input type="hidden" id="country" value={props.user.country} />
					<GlobalHeader toggleMenu={this.toggleMenu} logo={props.theme.centreLogoSecondary} content={props.pageContent.sideMenu} />
					<SideMenu toggleMenu={this.toggleMenu} menuOpen={this.state.menuOpen} content={props.pageContent.sideMenu} />
				</div>
			</ThemeProvider>
		)
	}

}

const mapStateToProps = ({ pageContent, theme, user }) => {
	return { pageContent, theme, user }
}

export default connect(
	mapStateToProps
)(Header)



// WEBPACK FOOTER //
// ./components/header/index.js